module.exports = __webpack_public_path__ + "static/img/lliaoliao_bg.be0cce86.png";